import { HALAL_I18N } from "@/i18n_halal";

// Top 10 globally spoken languages. `ar` and `ur` render right-to-left.
export const LANGUAGES = [
  { code: "en", label: "English", native: "English", rtl: false },
  { code: "zh", label: "Mandarin", native: "中文", rtl: false },
  { code: "hi", label: "Hindi", native: "हिन्दी", rtl: false },
  { code: "es", label: "Spanish", native: "Español", rtl: false },
  { code: "fr", label: "French", native: "Français", rtl: false },
  { code: "ar", label: "Arabic", native: "العربية", rtl: true },
  { code: "bn", label: "Bengali", native: "বাংলা", rtl: false },
  { code: "pt", label: "Portuguese", native: "Português", rtl: false },
  { code: "ru", label: "Russian", native: "Русский", rtl: false },
  { code: "ur", label: "Urdu", native: "اردو", rtl: true },
  { code: "tr", label: "Turkish", native: "Türkçe", rtl: false },
];

export const RTL_LANGS = LANGUAGES.filter((l) => l.rtl).map((l) => l.code);

export const translations = {
  en: {
    app_tagline: "GCC Wealth. Global Reach.",
    nav_dashboard: "Dashboard",
    nav_invest: "Invest",
    nav_trade_global: "Trade US Stocks",
    nav_world: "Trade World Stocks",
    nav_trade_gcc: "Trade GCC Stocks",
    nav_commodities: "Commodities",
    nav_forex: "Forex",
    nav_crypto: "Crypto",
    nav_save: "Save",
    nav_halal: "Halal",
    nav_murabaha: "Murabaha",
    nav_wallet: "Wallet",
    nav_profile: "Profile",
    nav_admin: "Admin",
    logout: "Log out",
    total_portfolio: "Total Portfolio Value",
    quick_actions: "Quick Actions",
    deposit: "Deposit",
    withdraw: "Withdraw",
    invest_now: "Invest",
    trade: "Trade",
    recent_activity: "Recent Activity",
    market_snapshot: "Market Snapshot",
    insights: "Personalized Insights",
    buy: "Buy",
    sell: "Sell",
    watchlist: "Watchlist",
    order_history: "Order History",
    positions: "Positions",
    balance: "Balance",
    apy: "Annual Yield",
    login: "Log in",
    register: "Create account",
    email: "Email",
    password: "Password",
    high_contrast: "High contrast",
    language: "Language",
    holdings: "Holdings",
    no_data: "No data yet",
  },
  zh: {
    app_tagline: "海湾财富，全球视野。",
    nav_dashboard: "仪表板",
    nav_invest: "投资",
    nav_trade_global: "交易美股",
    nav_world: "交易全球股票",
    nav_trade_gcc: "交易海湾股票",
    nav_commodities: "大宗商品",
    nav_forex: "外汇",
    nav_crypto: "加密货币",
    nav_save: "储蓄",
    nav_halal: "清真",
    nav_murabaha: "穆拉巴哈",
    nav_wallet: "钱包",
    nav_profile: "个人资料",
    nav_admin: "管理",
    logout: "退出登录",
    total_portfolio: "投资组合总值",
    quick_actions: "快捷操作",
    deposit: "存入",
    withdraw: "提取",
    invest_now: "投资",
    trade: "交易",
    recent_activity: "近期活动",
    market_snapshot: "市场概览",
    insights: "个性化洞察",
    buy: "买入",
    sell: "卖出",
    watchlist: "自选列表",
    order_history: "订单历史",
    positions: "持仓",
    balance: "余额",
    apy: "年化收益率",
    login: "登录",
    register: "创建账户",
    email: "电子邮件",
    password: "密码",
    high_contrast: "高对比度",
    language: "语言",
    holdings: "持有",
    no_data: "暂无数据",
  },
  hi: {
    app_tagline: "जीसीसी संपत्ति। वैश्विक पहुँच।",
    nav_dashboard: "डैशबोर्ड",
    nav_invest: "निवेश",
    nav_trade_global: "अमेरिकी स्टॉक ट्रेड करें",
    nav_world: "वैश्विक स्टॉक ट्रेड करें",
    nav_trade_gcc: "जीसीसी स्टॉक ट्रेड करें",
    nav_commodities: "कमोडिटीज़",
    nav_forex: "फॉरेक्स",
    nav_crypto: "क्रिप्टो",
    nav_save: "बचत",
    nav_halal: "हलाल",
    nav_murabaha: "मुराबहा",
    nav_wallet: "वॉलेट",
    nav_profile: "प्रोफ़ाइल",
    nav_admin: "एडमिन",
    logout: "लॉग आउट",
    total_portfolio: "कुल पोर्टफोलियो मूल्य",
    quick_actions: "त्वरित क्रियाएँ",
    deposit: "जमा करें",
    withdraw: "निकालें",
    invest_now: "निवेश करें",
    trade: "ट्रेड",
    recent_activity: "हाल की गतिविधि",
    market_snapshot: "बाज़ार झलक",
    insights: "व्यक्तिगत अंतर्दृष्टि",
    buy: "खरीदें",
    sell: "बेचें",
    watchlist: "वॉचलिस्ट",
    order_history: "ऑर्डर इतिहास",
    positions: "पोज़िशन",
    balance: "शेष राशि",
    apy: "वार्षिक प्रतिफल",
    login: "लॉग इन",
    register: "खाता बनाएँ",
    email: "ईमेल",
    password: "पासवर्ड",
    high_contrast: "उच्च कंट्रास्ट",
    language: "भाषा",
    holdings: "होल्डिंग्स",
    no_data: "अभी कोई डेटा नहीं",
  },
  es: {
    app_tagline: "Riqueza del CCG. Alcance global.",
    nav_dashboard: "Panel",
    nav_invest: "Invertir",
    nav_trade_global: "Operar acciones de EE. UU.",
    nav_world: "Operar acciones globales",
    nav_trade_gcc: "Operar acciones del CCG",
    nav_commodities: "Materias primas",
    nav_forex: "Forex",
    nav_crypto: "Cripto",
    nav_save: "Ahorrar",
    nav_halal: "Halal",
    nav_murabaha: "Murabaha",
    nav_wallet: "Cartera",
    nav_profile: "Perfil",
    nav_admin: "Administración",
    logout: "Cerrar sesión",
    total_portfolio: "Valor total de la cartera",
    quick_actions: "Acciones rápidas",
    deposit: "Depositar",
    withdraw: "Retirar",
    invest_now: "Invertir",
    trade: "Operar",
    recent_activity: "Actividad reciente",
    market_snapshot: "Resumen del mercado",
    insights: "Perspectivas personalizadas",
    buy: "Comprar",
    sell: "Vender",
    watchlist: "Lista de seguimiento",
    order_history: "Historial de órdenes",
    positions: "Posiciones",
    balance: "Saldo",
    apy: "Rendimiento anual",
    login: "Iniciar sesión",
    register: "Crear cuenta",
    email: "Correo electrónico",
    password: "Contraseña",
    high_contrast: "Alto contraste",
    language: "Idioma",
    holdings: "Tenencias",
    no_data: "Aún no hay datos",
  },
  fr: {
    app_tagline: "Richesse du CCG. Portée mondiale.",
    nav_dashboard: "Tableau de bord",
    nav_invest: "Investir",
    nav_trade_global: "Trader actions US",
    nav_world: "Trader actions mondiales",
    nav_trade_gcc: "Trader actions CCG",
    nav_commodities: "Matières premières",
    nav_forex: "Forex",
    nav_crypto: "Crypto",
    nav_save: "Épargner",
    nav_halal: "Halal",
    nav_murabaha: "Mourabaha",
    nav_wallet: "Portefeuille",
    nav_profile: "Profil",
    nav_admin: "Admin",
    logout: "Déconnexion",
    total_portfolio: "Valeur totale du portefeuille",
    quick_actions: "Actions rapides",
    deposit: "Déposer",
    withdraw: "Retirer",
    invest_now: "Investir",
    trade: "Trader",
    recent_activity: "Activité récente",
    market_snapshot: "Aperçu du marché",
    insights: "Analyses personnalisées",
    buy: "Acheter",
    sell: "Vendre",
    watchlist: "Liste de suivi",
    order_history: "Historique des ordres",
    positions: "Positions",
    balance: "Solde",
    apy: "Rendement annuel",
    login: "Se connecter",
    register: "Créer un compte",
    email: "E-mail",
    password: "Mot de passe",
    high_contrast: "Contraste élevé",
    language: "Langue",
    holdings: "Avoirs",
    no_data: "Pas encore de données",
  },
  ar: {
    app_tagline: "ثروة الخليج. آفاق عالمية.",
    nav_dashboard: "الرئيسية",
    nav_invest: "استثمر",
    nav_trade_global: "الأسهم الأمريكية",
    nav_world: "الأسواق العالمية",
    nav_trade_gcc: "تداول الخليج",
    nav_commodities: "السلع",
    nav_forex: "العملات",
    nav_crypto: "العملات الرقمية",
    nav_save: "الادخار",
    nav_halal: "حلال",
    nav_murabaha: "مرابحة",
    nav_wallet: "المحفظة",
    nav_profile: "الملف",
    nav_admin: "الإدارة",
    logout: "تسجيل الخروج",
    total_portfolio: "إجمالي قيمة المحفظة",
    quick_actions: "إجراءات سريعة",
    deposit: "إيداع",
    withdraw: "سحب",
    invest_now: "استثمر",
    trade: "تداول",
    recent_activity: "النشاط الأخير",
    market_snapshot: "لمحة السوق",
    insights: "رؤى مخصصة",
    buy: "شراء",
    sell: "بيع",
    watchlist: "قائمة المتابعة",
    order_history: "سجل الأوامر",
    positions: "المراكز",
    balance: "الرصيد",
    apy: "العائد السنوي",
    login: "تسجيل الدخول",
    register: "إنشاء حساب",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    high_contrast: "تباين عالٍ",
    language: "اللغة",
    holdings: "الحيازات",
    no_data: "لا توجد بيانات بعد",
  },
  bn: {
    app_tagline: "জিসিসি সম্পদ। বৈশ্বিক নাগাল।",
    nav_dashboard: "ড্যাশবোর্ড",
    nav_invest: "বিনিয়োগ",
    nav_trade_global: "মার্কিন স্টক ট্রেড",
    nav_world: "বৈশ্বিক স্টক ট্রেড",
    nav_trade_gcc: "জিসিসি স্টক ট্রেড",
    nav_commodities: "পণ্য",
    nav_forex: "ফরেক্স",
    nav_crypto: "ক্রিপ্টো",
    nav_save: "সঞ্চয়",
    nav_halal: "হালাল",
    nav_murabaha: "মুরাবাহা",
    nav_wallet: "ওয়ালেট",
    nav_profile: "প্রোফাইল",
    nav_admin: "অ্যাডমিন",
    logout: "লগ আউট",
    total_portfolio: "মোট পোর্টফোলিও মূল্য",
    quick_actions: "দ্রুত পদক্ষেপ",
    deposit: "জমা",
    withdraw: "উত্তোলন",
    invest_now: "বিনিয়োগ",
    trade: "ট্রেড",
    recent_activity: "সাম্প্রতিক কার্যকলাপ",
    market_snapshot: "বাজার সংক্ষিপ্তসার",
    insights: "ব্যক্তিগত অন্তর্দৃষ্টি",
    buy: "কিনুন",
    sell: "বিক্রি",
    watchlist: "ওয়াচলিস্ট",
    order_history: "অর্ডার ইতিহাস",
    positions: "পজিশন",
    balance: "ব্যালেন্স",
    apy: "বার্ষিক ফলন",
    login: "লগ ইন",
    register: "অ্যাকাউন্ট তৈরি করুন",
    email: "ইমেল",
    password: "পাসওয়ার্ড",
    high_contrast: "উচ্চ কনট্রাস্ট",
    language: "ভাষা",
    holdings: "হোল্ডিং",
    no_data: "এখনও কোনো তথ্য নেই",
  },
  pt: {
    app_tagline: "Riqueza do CCG. Alcance global.",
    nav_dashboard: "Painel",
    nav_invest: "Investir",
    nav_trade_global: "Negociar ações dos EUA",
    nav_world: "Negociar ações globais",
    nav_trade_gcc: "Negociar ações do CCG",
    nav_commodities: "Commodities",
    nav_forex: "Forex",
    nav_crypto: "Cripto",
    nav_save: "Poupar",
    nav_halal: "Halal",
    nav_murabaha: "Murabaha",
    nav_wallet: "Carteira",
    nav_profile: "Perfil",
    nav_admin: "Admin",
    logout: "Sair",
    total_portfolio: "Valor total da carteira",
    quick_actions: "Ações rápidas",
    deposit: "Depositar",
    withdraw: "Retirar",
    invest_now: "Investir",
    trade: "Negociar",
    recent_activity: "Atividade recente",
    market_snapshot: "Resumo do mercado",
    insights: "Insights personalizados",
    buy: "Comprar",
    sell: "Vender",
    watchlist: "Lista de observação",
    order_history: "Histórico de ordens",
    positions: "Posições",
    balance: "Saldo",
    apy: "Rendimento anual",
    login: "Entrar",
    register: "Criar conta",
    email: "E-mail",
    password: "Senha",
    high_contrast: "Alto contraste",
    language: "Idioma",
    holdings: "Participações",
    no_data: "Ainda sem dados",
  },
  ru: {
    app_tagline: "Богатство ССАГПЗ. Глобальный охват.",
    nav_dashboard: "Панель",
    nav_invest: "Инвестировать",
    nav_trade_global: "Торговать акциями США",
    nav_world: "Торговать мировыми акциями",
    nav_trade_gcc: "Торговать акциями ССАГПЗ",
    nav_commodities: "Сырьевые товары",
    nav_forex: "Форекс",
    nav_crypto: "Криптовалюта",
    nav_save: "Сбережения",
    nav_halal: "Халяль",
    nav_murabaha: "Мурабаха",
    nav_wallet: "Кошелёк",
    nav_profile: "Профиль",
    nav_admin: "Админ",
    logout: "Выйти",
    total_portfolio: "Общая стоимость портфеля",
    quick_actions: "Быстрые действия",
    deposit: "Пополнить",
    withdraw: "Вывести",
    invest_now: "Инвестировать",
    trade: "Торговать",
    recent_activity: "Недавняя активность",
    market_snapshot: "Обзор рынка",
    insights: "Персональная аналитика",
    buy: "Купить",
    sell: "Продать",
    watchlist: "Список наблюдения",
    order_history: "История ордеров",
    positions: "Позиции",
    balance: "Баланс",
    apy: "Годовая доходность",
    login: "Войти",
    register: "Создать аккаунт",
    email: "Эл. почта",
    password: "Пароль",
    high_contrast: "Высокий контраст",
    language: "Язык",
    holdings: "Активы",
    no_data: "Пока нет данных",
  },
  ur: {
    app_tagline: "جی سی سی دولت۔ عالمی رسائی۔",
    nav_dashboard: "ڈیش بورڈ",
    nav_invest: "سرمایہ کاری",
    nav_trade_global: "امریکی اسٹاک ٹریڈ کریں",
    nav_world: "عالمی اسٹاک ٹریڈ کریں",
    nav_trade_gcc: "جی سی سی اسٹاک ٹریڈ کریں",
    nav_commodities: "اجناس",
    nav_forex: "فاریکس",
    nav_crypto: "کرپٹو",
    nav_save: "بچت",
    nav_halal: "حلال",
    nav_murabaha: "مرابحہ",
    nav_wallet: "والیٹ",
    nav_profile: "پروفائل",
    nav_admin: "ایڈمن",
    logout: "لاگ آؤٹ",
    total_portfolio: "کل پورٹ فولیو ویلیو",
    quick_actions: "فوری اقدامات",
    deposit: "جمع کریں",
    withdraw: "نکالیں",
    invest_now: "سرمایہ کاری",
    trade: "ٹریڈ",
    recent_activity: "حالیہ سرگرمی",
    market_snapshot: "مارکیٹ کا خلاصہ",
    insights: "ذاتی بصیرت",
    buy: "خریدیں",
    sell: "فروخت",
    watchlist: "واچ لسٹ",
    order_history: "آرڈر کی تاریخ",
    positions: "پوزیشنز",
    balance: "بیلنس",
    apy: "سالانہ منافع",
    login: "لاگ ان",
    register: "اکاؤنٹ بنائیں",
    email: "ای میل",
    password: "پاس ورڈ",
    high_contrast: "ہائی کنٹراسٹ",
    language: "زبان",
    holdings: "ہولڈنگز",
    no_data: "ابھی کوئی ڈیٹا نہیں",
  },
  tr: {
    app_tagline: "Körfez Serveti. Küresel Erişim.",
    nav_dashboard: "Panel",
    nav_invest: "Yatırım",
    nav_trade_global: "ABD Hisseleri",
    nav_world: "Dünya Hisseleri",
    nav_trade_gcc: "Körfez Hisseleri",
    nav_commodities: "Emtialar",
    nav_forex: "Forex",
    nav_crypto: "Kripto",
    nav_save: "Biriktir",
    nav_halal: "Helal",
    nav_murabaha: "Murabaha",
    nav_wallet: "Cüzdan",
    nav_profile: "Profil",
    nav_admin: "Yönetim",
    logout: "Çıkış yap",
    total_portfolio: "Toplam Portföy Değeri",
    quick_actions: "Hızlı İşlemler",
    deposit: "Para Yatır",
    withdraw: "Para Çek",
    invest_now: "Yatırım",
    trade: "İşlem",
    recent_activity: "Son Etkinlik",
    market_snapshot: "Piyasa Özeti",
    insights: "Kişisel Analizler",
    buy: "Al",
    sell: "Sat",
    watchlist: "İzleme Listesi",
    order_history: "Emir Geçmişi",
    positions: "Pozisyonlar",
    balance: "Bakiye",
    apy: "Yıllık Getiri",
    login: "Giriş yap",
    register: "Hesap oluştur",
    email: "E-posta",
    password: "Şifre",
    high_contrast: "Yüksek kontrast",
    language: "Dil",
    holdings: "Varlıklar",
    no_data: "Henüz veri yok",
  },
};

// Page-level strings for Murabaha, Wallet and Alerts — merged into `translations`
// so the whole screen localizes. English keys act as fallback for any gap.
export const PAGE_I18N = {
  en: {
    cancel: "Cancel", refresh: "Refresh", active: "Active", triggered: "Triggered", delete: "Delete",
    nav_alerts: "Alerts",
    search_placeholder: "Search", search_hint: "Search a stock or jump to a screen",
    searching: "Searching…", search_no_match: "Nothing matched that",
    search_stocks: "Stocks & funds", search_pages: "Go to",
    mrb_title: "Commodity Murabaha",
    mrb_subtitle: "Shariah-compliant investing in real, physical agricultural commodity flows · up to 8% p.a.",
    mrb_available_flows: "Available Flows", mrb_your_contracts: "Your Contracts",
    mrb_invested_principal: "Invested Principal", mrb_accrued_profit: "Accrued Profit",
    mrb_current_value: "Current Value", mrb_active_contracts: "Active Contracts",
    mrb_invest: "Invest", mrb_target_rate: "Target rate", mrb_tenor: "Tenor", mrb_minimum: "Minimum",
    mrb_amount_usd: "Amount (USD)", mrb_projected_profit: "Projected profit at maturity",
    mrb_no_contracts: "No contracts yet",
    mrb_no_contracts_hint: "Invest in a commodity flow to start earning trade-based profit.",
    mrb_redeem_early: "Redeem early", mrb_redeem_matured: "Redeem (matured)",
    mrb_principal: "Principal", mrb_rate_tenor: "Rate / tenor", mrb_invested: "Invested",
    mrb_payout: "Payout", mrb_matures_in: "Matures in", mrb_matured: "Matured", mrb_days: "days",
    mrb_target_pa: "target p.a.", mrb_month_tenor: "month tenor",
    wlt_title: "Wallet", wlt_subtitle: "Unified QAR & USD balances · FX & transfers",
    wlt_qar_balance: "QAR Balance", wlt_usd_balance: "USD Balance", wlt_total_usd: "Total (USD equiv.)",
    wlt_portfolio_mix: "Portfolio Mix", wlt_net_worth: "Net worth", wlt_holdings_value: "Holdings value",
    wlt_total_pnl: "Total P&L", wlt_mix_history: "Mix History",
    wlt_mix_history_sub: "Net worth & asset blend over time",
    wlt_fx_convert: "FX Convert", wlt_from: "From", wlt_to: "To", wlt_amount: "Amount",
    wlt_you_receive: "You receive", wlt_convert: "Convert", wlt_method: "Method",
    wlt_bank_transfer: "Bank transfer", wlt_card: "Card", wlt_withdraw_bank: "Withdraw to bank",
    wlt_transactions: "Transactions", wlt_no_transactions: "No transactions", wlt_asset: "Asset",
    wlt_class: "Class", wlt_value: "Value", wlt_type: "Type", wlt_detail: "Detail", wlt_time: "Time",
    alr_title: "Price Alerts",
    alr_subtitle: "Get notified when a stock, crypto or commodity hits your target price",
    alr_create: "Create alert", alr_search: "Search symbol or name", alr_target_price: "Target price",
    alr_direction: "Direction", alr_rises_above: "Rises above", alr_falls_below: "Falls below",
    alr_current: "Current", alr_no_alerts: "No alerts yet",
    alr_no_alerts_hint: "Add a price alert and we'll notify you the moment it's hit.",
    alr_add: "Add alert",
    alr_alert_type: "Alert type", alr_type_price: "Target price",
    alr_type_percent_move: "% move from now", alr_type_daily_change: "Daily change",
    alr_up: "Up / Gain", alr_down: "Down / Loss", alr_percent: "Percent (%)",
    alr_from_current: "from current price", alr_when_daily: "when daily change crosses",
    // — client journey (added for full Arabic coverage) —
    cj_home: "Home", cj_help: "Help", cj_back: "Back", cj_more: "More", cj_close: "Close",
    cj_loading: "Loading…", cj_send: "Send", cj_save: "Save", cj_confirm: "Confirm",
    cj_total_balance: "Total balance", cj_todays_move: "Today's move", cj_cash: "Cash",
    cj_invested: "Invested", cj_gain: "Gain", cj_your_holdings: "Your holdings",
    cj_quick_actions: "Quick actions", cj_deposit: "Add money", cj_withdraw: "Send money",
    cj_qty: "Quantity", cj_price: "Price", cj_value: "Value",
    qb_buy: "Buy", qb_sell: "Sell", qb_how_much: "How much do you want to invest?",
    qb_you_get: "You get about", qb_shares: "shares", qb_checking: "Checking the price…",
    qb_swipe: "Swipe to invest", qb_more_options: "More options — sell, limit or stop",
    qb_today: "today", qb_settles: "settles in",
    hlp_title: "Talk to a real person",
    hlp_sub: "Ask us anything about opening an account, moving money or investing. We answer every message within one working day.",
    hlp_email_us: "Email us", hlp_whatsapp: "WhatsApp", hlp_call_us: "Call us",
    hlp_send_message: "Send us a message", hlp_your_name: "Your name", hlp_your_message: "Your message",
    hlp_about: "What is it about?", hlp_phone_opt: "Phone (optional)",
    hlp_send: "Send message", hlp_sending: "Sending…", hlp_send_another: "Send another",
    hlp_faq: "Common questions", hlp_chat_with_us: "Chat with us",
    hlp_help_desk: "Tharwy help desk", hlp_maya_instant: "Maya replies instantly",
    hlp_maya_typing: "Maya is typing…", hlp_type_message: "Type a message",
    hlp_continue_whatsapp: "Continue on WhatsApp",
    hlp_greeting: "Hi! I'm Maya from Tharwy. Ask me anything about opening an account, moving money or investing — I'll answer right away.",
    hlp_q_cost: "What does it cost?", hlp_q_buy: "How do I buy a stock?",
    hlp_q_halal: "Is it Shariah-compliant?", hlp_q_withdraw: "How fast are withdrawals?",
    zk_title: "Zakat & purification",
    zk_sub: "What you owe on the wealth you hold, and the dividend income that needs cleansing — worked out from your live balances.",
    zk_give_zakat: "Give zakat", zk_outstanding: "Zakat outstanding", zk_wealth: "Zakatable wealth",
    zk_purification: "Purification owed", zk_days: "Days to your zakat date",
    zk_how: "How we worked it out", zk_nisab: "Nisab", zk_your_year: "Your zakat year",
    zk_given: "What you have given", zk_certificate: "Certificate",
    pro_mode: "Pro mode",
    pro_mode_hint: "Off keeps things simple: invest, stocks, savings and your wallet. On adds the trading desk, order book, insights and price alerts.",
    nav_g_stocks: "Stocks", nav_g_markets: "Markets", nav_g_money: "Money", nav_g_islamic: "Islamic",
    nav_g_overview: "Overview", nav_orders: "Orders", nav_live: "Live", nav_insights: "Insights",
    nav_eu: "EU Stocks", nav_asia: "Asian Stocks", nav_world: "World Stocks", nav_zakat: "Zakat",
    nav_dividends: "Dividends",
    dv_title: "Dividends & corporate actions",
    dv_sub: "Every cash dividend your holdings pay lands in your wallet, and share splits adjust your holding automatically — worked out from company filings.",
    dv_reinvest: "Reinvest dividends",
    dv_reinvest_hint: "With this on, each dividend is used to buy more of the same share or fund at the price on the day. Off, it stays as cash in your USD wallet.",
    tr_us_title: "Trade US", tr_gcc_title: "Trade GCC",
    tr_us_sub: "US stocks & ETFs · $0 commission · fractional shares",
    tr_watchlist: "Watchlist", tr_positions: "Positions", tr_order_history: "Order history",
    tr_trade: "Trade", tr_protect: "Protect", tr_search: "Search tickers (AAPL, VOO…)",
    tr_symbol: "Symbol", tr_avg: "Avg", tr_pnl: "P&L", tr_news: "Market news",
    ld_nav_trade: "Trade", ld_nav_invest: "Invest", ld_nav_save: "Save", ld_nav_halal: "Halal",
    ld_nav_pricing: "Pricing", ld_sign_in: "Sign in", ld_get_started: "Get started",
    ld_badge: "Smart, halal, global investing",
    ld_h1a: "One account for", ld_h1b: "the world's markets —", ld_h1c: "built for everyone.",
    ld_sub: "Global & GCC stocks, Shariah-compliant portfolios, USD high-yield savings and multi-currency accounts in your home currency — all in one secure, intuitive platform.",
    ld_cta_open: "Open free account", ld_cta_explore: "Explore markets",
    ld_trust_min: "$0 account minimum", ld_trust_shariah: "Shariah certified",
    ld_trust_enc: "256-bit encryption", ld_secured: "Secured with 256-bit SSL encryption",
    zk_l_cash: "Cash in your wallets", zk_l_savings: "USD savings",
    zk_l_murabaha: "Murabaha placements", zk_l_shares: "Shares & ETFs",
    zk_l_total: "Zakatable wealth", zk_l_rate: "Zakat at 2.50%", zk_l_paid: "Already given this year",
    hlp_hours: "Sunday to Thursday, 8am – 8pm Doha time",
    hlp_name_ph: "Ahmed Al-Thani", hlp_msg_ph: "Tell us how we can help…",
    hlp_t_account: "Opening or verifying my account", hlp_t_money: "Deposits, withdrawals and currencies",
    hlp_t_investing: "Investing, portfolios and stocks", hlp_t_islamic: "Shariah screening and zakat",
    hlp_t_technical: "Something isn't working", hlp_t_other: "Something else",
    mt_us: "US", mt_me: "Middle East", mt_eu: "Europe", mt_asia: "Asia", mt_world: "World",
    mt_fx: "FX", mt_comm: "Commodities", mt_crypto: "Crypto",
    tr_news_us: "US Market News", ld_talk: "Talk to our team", ld_helpdesk: "Help desk",
    zk_n_cash: "Every currency you hold, valued in USD.",
    zk_n_savings: "Balance plus the profit already credited.",
    zk_n_murabaha: "Active contracts at cost plus accrued profit.",
    zk_n_shares: "Market value — shares held for trading are zakatable in full.",
  },
  zh: {
    cancel: "取消", refresh: "刷新", active: "生效中", triggered: "已触发", delete: "删除",
    nav_alerts: "提醒",
    mrb_title: "商品穆拉巴哈",
    mrb_subtitle: "符合伊斯兰教法的真实实物农产品流投资 · 年化最高 8%",
    mrb_available_flows: "可选方案", mrb_your_contracts: "您的合约",
    mrb_invested_principal: "投资本金", mrb_accrued_profit: "累计利润",
    mrb_current_value: "当前价值", mrb_active_contracts: "有效合约",
    mrb_invest: "投资", mrb_target_rate: "目标利率", mrb_tenor: "期限", mrb_minimum: "最低",
    mrb_amount_usd: "金额（美元）", mrb_projected_profit: "到期预计利润",
    mrb_no_contracts: "暂无合约",
    mrb_no_contracts_hint: "投资一个商品流即可开始赚取基于交易的利润。",
    mrb_redeem_early: "提前赎回", mrb_redeem_matured: "赎回（已到期）",
    mrb_principal: "本金", mrb_rate_tenor: "利率 / 期限", mrb_invested: "已投资",
    mrb_payout: "赎回金额", mrb_matures_in: "到期还有", mrb_matured: "已到期", mrb_days: "天",
    mrb_target_pa: "目标年化", mrb_month_tenor: "个月期限",
    wlt_title: "钱包", wlt_subtitle: "统一的 QAR 与 USD 余额 · 外汇与转账",
    wlt_qar_balance: "QAR 余额", wlt_usd_balance: "USD 余额", wlt_total_usd: "总额（美元等值）",
    wlt_portfolio_mix: "投资组合构成", wlt_net_worth: "净资产", wlt_holdings_value: "持仓价值",
    wlt_total_pnl: "总盈亏", wlt_mix_history: "组合历史",
    wlt_mix_history_sub: "净资产与资产构成随时间变化",
    wlt_fx_convert: "外汇兑换", wlt_from: "从", wlt_to: "到", wlt_amount: "金额",
    wlt_you_receive: "您将获得", wlt_convert: "兑换", wlt_method: "方式",
    wlt_bank_transfer: "银行转账", wlt_card: "银行卡", wlt_withdraw_bank: "提现到银行",
    wlt_transactions: "交易记录", wlt_no_transactions: "暂无交易", wlt_asset: "资产",
    wlt_class: "类别", wlt_value: "价值", wlt_type: "类型", wlt_detail: "详情", wlt_time: "时间",
    alr_title: "价格提醒",
    alr_subtitle: "当股票、加密货币或大宗商品达到目标价时通知您",
    alr_create: "创建提醒", alr_search: "搜索代码或名称", alr_target_price: "目标价格",
    alr_direction: "方向", alr_rises_above: "涨破", alr_falls_below: "跌破",
    alr_current: "当前", alr_no_alerts: "暂无提醒",
    alr_no_alerts_hint: "添加价格提醒，达到时我们会立即通知您。",
    alr_add: "添加提醒",
  },
  hi: {
    cancel: "रद्द करें", refresh: "रिफ्रेश", active: "सक्रिय", triggered: "ट्रिगर हुआ", delete: "हटाएँ",
    nav_alerts: "अलर्ट",
    mrb_title: "कमोडिटी मुराबहा",
    mrb_subtitle: "वास्तविक भौतिक कृषि कमोडिटी प्रवाह में शरिया-अनुरूप निवेश · वार्षिक 8% तक",
    mrb_available_flows: "उपलब्ध फ्लो", mrb_your_contracts: "आपके अनुबंध",
    mrb_invested_principal: "निवेशित मूलधन", mrb_accrued_profit: "अर्जित लाभ",
    mrb_current_value: "वर्तमान मूल्य", mrb_active_contracts: "सक्रिय अनुबंध",
    mrb_invest: "निवेश", mrb_target_rate: "लक्ष्य दर", mrb_tenor: "अवधि", mrb_minimum: "न्यूनतम",
    mrb_amount_usd: "राशि (USD)", mrb_projected_profit: "परिपक्वता पर अनुमानित लाभ",
    mrb_no_contracts: "अभी कोई अनुबंध नहीं",
    mrb_no_contracts_hint: "व्यापार-आधारित लाभ कमाने के लिए किसी कमोडिटी फ्लो में निवेश करें।",
    mrb_redeem_early: "जल्दी भुनाएँ", mrb_redeem_matured: "भुनाएँ (परिपक्व)",
    mrb_principal: "मूलधन", mrb_rate_tenor: "दर / अवधि", mrb_invested: "निवेशित",
    mrb_payout: "भुगतान", mrb_matures_in: "परिपक्वता में", mrb_matured: "परिपक्व", mrb_days: "दिन",
    mrb_target_pa: "लक्ष्य प्रति वर्ष", mrb_month_tenor: "माह की अवधि",
    wlt_title: "वॉलेट", wlt_subtitle: "एकीकृत QAR और USD शेष · FX और ट्रांसफर",
    wlt_qar_balance: "QAR शेष", wlt_usd_balance: "USD शेष", wlt_total_usd: "कुल (USD समकक्ष)",
    wlt_portfolio_mix: "पोर्टफोलियो मिश्रण", wlt_net_worth: "निवल संपत्ति", wlt_holdings_value: "होल्डिंग्स मूल्य",
    wlt_total_pnl: "कुल लाभ/हानि", wlt_mix_history: "मिश्रण इतिहास",
    wlt_mix_history_sub: "समय के साथ निवल संपत्ति और परिसंपत्ति मिश्रण",
    wlt_fx_convert: "FX परिवर्तन", wlt_from: "से", wlt_to: "तक", wlt_amount: "राशि",
    wlt_you_receive: "आपको मिलेगा", wlt_convert: "बदलें", wlt_method: "तरीका",
    wlt_bank_transfer: "बैंक ट्रांसफर", wlt_card: "कार्ड", wlt_withdraw_bank: "बैंक में निकालें",
    wlt_transactions: "लेन-देन", wlt_no_transactions: "कोई लेन-देन नहीं", wlt_asset: "परिसंपत्ति",
    wlt_class: "श्रेणी", wlt_value: "मूल्य", wlt_type: "प्रकार", wlt_detail: "विवरण", wlt_time: "समय",
    alr_title: "मूल्य अलर्ट",
    alr_subtitle: "जब कोई स्टॉक, क्रिप्टो या कमोडिटी आपके लक्ष्य मूल्य पर पहुँचे तो सूचना पाएँ",
    alr_create: "अलर्ट बनाएँ", alr_search: "सिंबल या नाम खोजें", alr_target_price: "लक्ष्य मूल्य",
    alr_direction: "दिशा", alr_rises_above: "से ऊपर जाए", alr_falls_below: "से नीचे गिरे",
    alr_current: "वर्तमान", alr_no_alerts: "अभी कोई अलर्ट नहीं",
    alr_no_alerts_hint: "एक मूल्य अलर्ट जोड़ें और पहुँचते ही हम आपको सूचित करेंगे।",
    alr_add: "अलर्ट जोड़ें",
  },
  es: {
    cancel: "Cancelar", refresh: "Actualizar", active: "Activa", triggered: "Activada", delete: "Eliminar",
    nav_alerts: "Alertas",
    mrb_title: "Murabaha de Materias Primas",
    mrb_subtitle: "Inversión conforme a la Sharía en flujos reales de materias primas agrícolas · hasta 8% anual",
    mrb_available_flows: "Flujos disponibles", mrb_your_contracts: "Tus contratos",
    mrb_invested_principal: "Capital invertido", mrb_accrued_profit: "Beneficio acumulado",
    mrb_current_value: "Valor actual", mrb_active_contracts: "Contratos activos",
    mrb_invest: "Invertir", mrb_target_rate: "Tasa objetivo", mrb_tenor: "Plazo", mrb_minimum: "Mínimo",
    mrb_amount_usd: "Importe (USD)", mrb_projected_profit: "Beneficio previsto al vencimiento",
    mrb_no_contracts: "Aún no hay contratos",
    mrb_no_contracts_hint: "Invierte en un flujo de materias primas para empezar a ganar beneficio comercial.",
    mrb_redeem_early: "Rescatar anticipado", mrb_redeem_matured: "Rescatar (vencido)",
    mrb_principal: "Capital", mrb_rate_tenor: "Tasa / plazo", mrb_invested: "Invertido",
    mrb_payout: "Pago", mrb_matures_in: "Vence en", mrb_matured: "Vencido", mrb_days: "días",
    mrb_target_pa: "objetivo anual", mrb_month_tenor: "meses de plazo",
    wlt_title: "Cartera", wlt_subtitle: "Saldos unificados QAR y USD · FX y transferencias",
    wlt_qar_balance: "Saldo QAR", wlt_usd_balance: "Saldo USD", wlt_total_usd: "Total (equiv. USD)",
    wlt_portfolio_mix: "Composición de cartera", wlt_net_worth: "Patrimonio neto", wlt_holdings_value: "Valor de posiciones",
    wlt_total_pnl: "P&L total", wlt_mix_history: "Historial de composición",
    wlt_mix_history_sub: "Patrimonio y mezcla de activos a lo largo del tiempo",
    wlt_fx_convert: "Conversión FX", wlt_from: "De", wlt_to: "A", wlt_amount: "Importe",
    wlt_you_receive: "Recibes", wlt_convert: "Convertir", wlt_method: "Método",
    wlt_bank_transfer: "Transferencia bancaria", wlt_card: "Tarjeta", wlt_withdraw_bank: "Retirar al banco",
    wlt_transactions: "Transacciones", wlt_no_transactions: "Sin transacciones", wlt_asset: "Activo",
    wlt_class: "Clase", wlt_value: "Valor", wlt_type: "Tipo", wlt_detail: "Detalle", wlt_time: "Hora",
    alr_title: "Alertas de precio",
    alr_subtitle: "Recibe un aviso cuando una acción, cripto o materia prima alcance tu precio objetivo",
    alr_create: "Crear alerta", alr_search: "Buscar símbolo o nombre", alr_target_price: "Precio objetivo",
    alr_direction: "Dirección", alr_rises_above: "Sube por encima de", alr_falls_below: "Cae por debajo de",
    alr_current: "Actual", alr_no_alerts: "Aún no hay alertas",
    alr_no_alerts_hint: "Añade una alerta de precio y te avisaremos en cuanto se cumpla.",
    alr_add: "Añadir alerta",
  },
  fr: {
    cancel: "Annuler", refresh: "Actualiser", active: "Active", triggered: "Déclenchée", delete: "Supprimer",
    nav_alerts: "Alertes",
    mrb_title: "Mourabaha sur Matières Premières",
    mrb_subtitle: "Investissement conforme à la Charia dans des flux réels de matières premières agricoles · jusqu'à 8% par an",
    mrb_available_flows: "Flux disponibles", mrb_your_contracts: "Vos contrats",
    mrb_invested_principal: "Capital investi", mrb_accrued_profit: "Profit accumulé",
    mrb_current_value: "Valeur actuelle", mrb_active_contracts: "Contrats actifs",
    mrb_invest: "Investir", mrb_target_rate: "Taux cible", mrb_tenor: "Durée", mrb_minimum: "Minimum",
    mrb_amount_usd: "Montant (USD)", mrb_projected_profit: "Profit prévu à l'échéance",
    mrb_no_contracts: "Aucun contrat pour l'instant",
    mrb_no_contracts_hint: "Investissez dans un flux de matières premières pour générer un profit commercial.",
    mrb_redeem_early: "Racheter par anticipation", mrb_redeem_matured: "Racheter (échu)",
    mrb_principal: "Capital", mrb_rate_tenor: "Taux / durée", mrb_invested: "Investi",
    mrb_payout: "Versement", mrb_matures_in: "Échéance dans", mrb_matured: "Échu", mrb_days: "jours",
    mrb_target_pa: "cible par an", mrb_month_tenor: "mois de durée",
    wlt_title: "Portefeuille", wlt_subtitle: "Soldes QAR et USD unifiés · FX et transferts",
    wlt_qar_balance: "Solde QAR", wlt_usd_balance: "Solde USD", wlt_total_usd: "Total (équiv. USD)",
    wlt_portfolio_mix: "Composition du portefeuille", wlt_net_worth: "Valeur nette", wlt_holdings_value: "Valeur des positions",
    wlt_total_pnl: "P&L total", wlt_mix_history: "Historique de composition",
    wlt_mix_history_sub: "Valeur nette et mix d'actifs dans le temps",
    wlt_fx_convert: "Conversion FX", wlt_from: "De", wlt_to: "Vers", wlt_amount: "Montant",
    wlt_you_receive: "Vous recevez", wlt_convert: "Convertir", wlt_method: "Méthode",
    wlt_bank_transfer: "Virement bancaire", wlt_card: "Carte", wlt_withdraw_bank: "Retirer vers la banque",
    wlt_transactions: "Transactions", wlt_no_transactions: "Aucune transaction", wlt_asset: "Actif",
    wlt_class: "Classe", wlt_value: "Valeur", wlt_type: "Type", wlt_detail: "Détail", wlt_time: "Heure",
    alr_title: "Alertes de prix",
    alr_subtitle: "Soyez averti quand une action, une crypto ou une matière première atteint votre prix cible",
    alr_create: "Créer une alerte", alr_search: "Rechercher un symbole ou un nom", alr_target_price: "Prix cible",
    alr_direction: "Direction", alr_rises_above: "Rises above", alr_falls_below: "Falls below",
    alr_current: "Current", alr_no_alerts: "No alerts yet",
    alr_no_alerts_hint: "Add a price alert and we'll tell you the moment it is hit.",
    alr_add: "Add alert",
  },
  ar: {
    cancel: "إلغاء", refresh: "تحديث", active: "نشط", triggered: "تم التنبيه", delete: "حذف",
    nav_alerts: "التنبيهات",
    search_placeholder: "بحث", search_hint: "ابحث عن سهم أو انتقل إلى شاشة",
    searching: "جارٍ البحث…", search_no_match: "لا توجد نتائج مطابقة",
    search_stocks: "الأسهم والصناديق", search_pages: "الانتقال إلى",
    mrb_title: "مرابحة السلع",
    mrb_subtitle: "استثمار متوافق مع الشريعة في تدفقات سلع زراعية مادية حقيقية · حتى 8% سنويًا",
    mrb_available_flows: "التدفقات المتاحة", mrb_your_contracts: "عقودك",
    mrb_invested_principal: "رأس المال المستثمر", mrb_accrued_profit: "الربح المتراكم",
    mrb_current_value: "القيمة الحالية", mrb_active_contracts: "العقود النشطة",
    mrb_invest: "استثمر", mrb_target_rate: "المعدل المستهدف", mrb_tenor: "المدة", mrb_minimum: "الحد الأدنى",
    mrb_amount_usd: "المبلغ (USD)", mrb_projected_profit: "الربح المتوقع عند الاستحقاق",
    mrb_no_contracts: "لا توجد عقود بعد",
    mrb_no_contracts_hint: "استثمر في تدفق سلعي لتبدأ في تحقيق ربح قائم على التجارة.",
    mrb_redeem_early: "استرداد مبكر", mrb_redeem_matured: "استرداد (مستحق)",
    mrb_principal: "رأس المال", mrb_rate_tenor: "المعدل / المدة", mrb_invested: "المستثمر",
    mrb_payout: "المبلغ المسترد", mrb_matures_in: "يستحق خلال", mrb_matured: "مستحق", mrb_days: "يوم",
    mrb_target_pa: "المستهدف سنويًا", mrb_month_tenor: "شهرًا مدة",
    wlt_title: "المحفظة", wlt_subtitle: "أرصدة موحدة بالريال والدولار · صرف وتحويلات",
    wlt_qar_balance: "رصيد QAR", wlt_usd_balance: "رصيد USD", wlt_total_usd: "الإجمالي (بما يعادل USD)",
    wlt_portfolio_mix: "مكوّنات المحفظة", wlt_net_worth: "صافي الثروة", wlt_holdings_value: "قيمة الحيازات",
    wlt_total_pnl: "إجمالي الأرباح/الخسائر", wlt_mix_history: "سجل المكوّنات",
    wlt_mix_history_sub: "صافي الثروة ومزيج الأصول عبر الزمن",
    wlt_fx_convert: "تحويل العملات", wlt_from: "من", wlt_to: "إلى", wlt_amount: "المبلغ",
    wlt_you_receive: "ستستلم", wlt_convert: "تحويل", wlt_method: "الطريقة",
    wlt_bank_transfer: "تحويل بنكي", wlt_card: "بطاقة", wlt_withdraw_bank: "سحب إلى البنك",
    wlt_transactions: "المعاملات", wlt_no_transactions: "لا توجد معاملات", wlt_asset: "الأصل",
    wlt_class: "الفئة", wlt_value: "القيمة", wlt_type: "النوع", wlt_detail: "التفاصيل", wlt_time: "الوقت",
    alr_title: "تنبيهات الأسعار",
    alr_subtitle: "احصل على إشعار عندما يصل سهم أو عملة رقمية أو سلعة إلى سعرك المستهدف",
    alr_create: "إنشاء تنبيه", alr_search: "ابحث بالرمز أو الاسم", alr_target_price: "السعر المستهدف",
    alr_direction: "الاتجاه", alr_rises_above: "يرتفع فوق", alr_falls_below: "ينخفض دون",
    alr_current: "الحالي", alr_no_alerts: "لا توجد تنبيهات بعد",
    alr_no_alerts_hint: "أضف تنبيه سعر وسنخطرك فور تحققه.",
    alr_add: "إضافة تنبيه",
    // — رحلة العميل —
    cj_home: "الرئيسية", cj_help: "المساعدة", cj_back: "رجوع", cj_more: "المزيد", cj_close: "إغلاق",
    cj_loading: "جارٍ التحميل…", cj_send: "إرسال", cj_save: "حفظ", cj_confirm: "تأكيد",
    cj_total_balance: "إجمالي الرصيد", cj_todays_move: "حركة اليوم", cj_cash: "النقد",
    cj_invested: "المستثمر", cj_gain: "الأرباح", cj_your_holdings: "ممتلكاتك",
    cj_quick_actions: "إجراءات سريعة", cj_deposit: "إضافة أموال", cj_withdraw: "تحويل أموال",
    cj_qty: "الكمية", cj_price: "السعر", cj_value: "القيمة",
    qb_buy: "شراء", qb_sell: "بيع", qb_how_much: "كم ترغب في استثماره؟",
    qb_you_get: "ستحصل على نحو", qb_shares: "سهم", qb_checking: "جارٍ التحقق من السعر…",
    qb_swipe: "اسحب للاستثمار", qb_more_options: "خيارات أكثر — بيع أو سعر محدد أو أمر إيقاف",
    qb_today: "اليوم", qb_settles: "تُسوّى بعملة",
    hlp_title: "تحدّث إلى شخص حقيقي",
    hlp_sub: "اسألنا عن أي شيء يتعلق بفتح الحساب أو تحويل الأموال أو الاستثمار. نرد على كل رسالة خلال يوم عمل واحد.",
    hlp_email_us: "راسلنا بالبريد", hlp_whatsapp: "واتساب", hlp_call_us: "اتصل بنا",
    hlp_send_message: "أرسل لنا رسالة", hlp_your_name: "اسمك", hlp_your_message: "رسالتك",
    hlp_about: "ما موضوع الرسالة؟", hlp_phone_opt: "الهاتف (اختياري)",
    hlp_send: "إرسال الرسالة", hlp_sending: "جارٍ الإرسال…", hlp_send_another: "إرسال رسالة أخرى",
    hlp_faq: "الأسئلة الشائعة", hlp_chat_with_us: "تحدّث معنا",
    hlp_help_desk: "مكتب مساعدة موركس", hlp_maya_instant: "مايا ترد فورًا",
    hlp_maya_typing: "مايا تكتب…", hlp_type_message: "اكتب رسالة",
    hlp_continue_whatsapp: "أكمل على واتساب",
    hlp_greeting: "مرحبًا! أنا مايا من موركس. اسألني عن فتح الحساب أو تحويل الأموال أو الاستثمار وسأجيبك على الفور.",
    hlp_q_cost: "ما هي التكاليف؟", hlp_q_buy: "كيف أشتري سهمًا؟",
    hlp_q_halal: "هل الخدمة متوافقة مع الشريعة؟", hlp_q_withdraw: "ما سرعة السحب؟",
    zk_title: "الزكاة والتطهير",
    zk_sub: "ما يجب عليك في الثروة التي تملكها، ودخل الأرباح الذي يحتاج إلى تطهير — محسوبًا من أرصدتك الحيّة.",
    zk_give_zakat: "أدِّ الزكاة", zk_outstanding: "الزكاة المستحقة", zk_wealth: "الثروة الزكوية",
    zk_purification: "التطهير المستحق", zk_days: "الأيام حتى موعد زكاتك",
    zk_how: "كيف حسبناها", zk_nisab: "النصاب", zk_your_year: "سنتك الزكوية",
    zk_given: "ما قدّمته", zk_certificate: "الشهادة",
    pro_mode: "الوضع المتقدم",
    pro_mode_hint: "عند الإيقاف تبقى التجربة بسيطة: الاستثمار والأسهم والتوفير ومحفظتك. وعند التشغيل تُضاف منصة التداول وسجل الأوامر والتحليلات وتنبيهات الأسعار.",
    nav_g_stocks: "الأسهم", nav_g_markets: "الأسواق", nav_g_money: "الأموال", nav_g_islamic: "إسلامي",
    nav_g_overview: "نظرة عامة", nav_orders: "الأوامر", nav_live: "مباشر", nav_insights: "التحليلات",
    nav_eu: "أسهم أوروبا", nav_asia: "أسهم آسيا", nav_world: "أسهم العالم", nav_zakat: "الزكاة",
    nav_dividends: "التوزيعات",
    dv_title: "التوزيعات وإجراءات الشركات",
    dv_sub: "كل توزيع نقدي تدفعه أسهمك يُضاف إلى محفظتك، وتُعدَّل حصصك تلقائياً عند تجزئة الأسهم — بناءً على إفصاحات الشركات.",
    dv_reinvest: "إعادة استثمار التوزيعات",
    dv_reinvest_hint: "عند التشغيل نستخدم كل توزيع لشراء المزيد من السهم أو الصندوق نفسه بسعر اليوم. وعند الإيقاف يبقى المبلغ نقداً في محفظتك بالدولار.",
    tr_us_title: "تداول أمريكا", tr_gcc_title: "تداول الخليج",
    tr_us_sub: "أسهم وصناديق أمريكية · بدون عمولة · أسهم جزئية",
    tr_watchlist: "قائمة المتابعة", tr_positions: "المراكز", tr_order_history: "سجل الأوامر",
    tr_trade: "تداول", tr_protect: "حماية", tr_search: "ابحث عن رمز (AAPL، VOO…)",
    tr_symbol: "الرمز", tr_avg: "المتوسط", tr_pnl: "الربح والخسارة", tr_news: "أخبار السوق",
    ld_nav_trade: "التداول", ld_nav_invest: "الاستثمار", ld_nav_save: "التوفير", ld_nav_halal: "الحلال",
    ld_nav_pricing: "الأسعار", ld_sign_in: "تسجيل الدخول", ld_get_started: "ابدأ الآن",
    ld_badge: "استثمار عالمي ذكي ومتوافق مع الشريعة",
    ld_h1a: "حساب واحد", ld_h1b: "لأسواق العالم —", ld_h1c: "مصمّم للجميع.",
    ld_sub: "أسهم عالمية وخليجية، ومحافظ متوافقة مع الشريعة، وتوفير بالدولار بعائد مرتفع، وحسابات متعددة العملات بعملتك المحلية — كل ذلك في منصة واحدة آمنة وسهلة.",
    ld_cta_open: "افتح حسابًا مجانًا", ld_cta_explore: "استكشف الأسواق",
    ld_trust_min: "بدون حد أدنى للحساب", ld_trust_shariah: "معتمد شرعيًا",
    ld_trust_enc: "تشفير 256-بت", ld_secured: "محمي بتشفير SSL بطول 256 بت",
    zk_l_cash: "النقد في محافظك", zk_l_savings: "التوفير بالدولار",
    zk_l_murabaha: "عقود المرابحة", zk_l_shares: "الأسهم والصناديق",
    zk_l_total: "الثروة الزكوية", zk_l_rate: "الزكاة بنسبة 2.50%", zk_l_paid: "ما أُدّي هذا العام",
    hlp_hours: "من الأحد إلى الخميس، 8 صباحًا – 8 مساءً بتوقيت الدوحة",
    hlp_name_ph: "أحمد آل ثاني", hlp_msg_ph: "أخبرنا كيف نساعدك…",
    hlp_t_account: "فتح الحساب أو التحقق منه", hlp_t_money: "الإيداع والسحب والعملات",
    hlp_t_investing: "الاستثمار والمحافظ والأسهم", hlp_t_islamic: "الفرز الشرعي والزكاة",
    hlp_t_technical: "هناك خطأ ما", hlp_t_other: "موضوع آخر",
    mt_us: "أمريكا", mt_me: "الشرق الأوسط", mt_eu: "أوروبا", mt_asia: "آسيا", mt_world: "العالم",
    mt_fx: "العملات", mt_comm: "السلع", mt_crypto: "العملات الرقمية",
    tr_news_us: "أخبار السوق الأمريكي", ld_talk: "تحدّث إلى فريقنا", ld_helpdesk: "مكتب المساعدة",
    zk_n_cash: "كل عملة تملكها، مقوّمة بالدولار.",
    zk_n_savings: "الرصيد مع الأرباح المضافة بالفعل.",
    zk_n_murabaha: "العقود النشطة بالتكلفة مع الأرباح المستحقة.",
    zk_n_shares: "القيمة السوقية — الأسهم المحتفظ بها للتداول زكوية بكاملها.",
  },
  bn: {
    cancel: "বাতিল", refresh: "রিফ্রেশ", active: "সক্রিয়", triggered: "ট্রিগার হয়েছে", delete: "মুছুন",
    nav_alerts: "অ্যালার্ট",
    mrb_title: "কমোডিটি মুরাবাহা",
    mrb_subtitle: "প্রকৃত ভৌত কৃষি পণ্য প্রবাহে শরিয়াহ-সম্মত বিনিয়োগ · বছরে ৮% পর্যন্ত",
    mrb_available_flows: "উপলব্ধ ফ্লো", mrb_your_contracts: "আপনার চুক্তি",
    mrb_invested_principal: "বিনিয়োগকৃত মূলধন", mrb_accrued_profit: "সঞ্চিত মুনাফা",
    mrb_current_value: "বর্তমান মূল্য", mrb_active_contracts: "সক্রিয় চুক্তি",
    mrb_invest: "বিনিয়োগ", mrb_target_rate: "লক্ষ্য হার", mrb_tenor: "মেয়াদ", mrb_minimum: "ন্যূনতম",
    mrb_amount_usd: "পরিমাণ (USD)", mrb_projected_profit: "মেয়াদপূর্তিতে প্রত্যাশিত মুনাফা",
    mrb_no_contracts: "এখনও কোনো চুক্তি নেই",
    mrb_no_contracts_hint: "বাণিজ্য-ভিত্তিক মুনাফা অর্জন শুরু করতে একটি পণ্য প্রবাহে বিনিয়োগ করুন।",
    mrb_redeem_early: "আগাম উত্তোলন", mrb_redeem_matured: "উত্তোলন (মেয়াদপূর্ণ)",
    mrb_principal: "মূলধন", mrb_rate_tenor: "হার / মেয়াদ", mrb_invested: "বিনিয়োগকৃত",
    mrb_payout: "পরিশোধ", mrb_matures_in: "মেয়াদপূর্তি বাকি", mrb_matured: "মেয়াদপূর্ণ", mrb_days: "দিন",
    mrb_target_pa: "লক্ষ্য বার্ষিক", mrb_month_tenor: "মাসের মেয়াদ",
    wlt_title: "ওয়ালেট", wlt_subtitle: "একীভূত QAR ও USD ব্যালেন্স · FX ও ট্রান্সফার",
    wlt_qar_balance: "QAR ব্যালেন্স", wlt_usd_balance: "USD ব্যালেন্স", wlt_total_usd: "মোট (USD সমতুল্য)",
    wlt_portfolio_mix: "পোর্টফোলিও মিশ্রণ", wlt_net_worth: "নিট সম্পদ", wlt_holdings_value: "হোল্ডিংয়ের মূল্য",
    wlt_total_pnl: "মোট লাভ/ক্ষতি", wlt_mix_history: "মিশ্রণ ইতিহাস",
    wlt_mix_history_sub: "সময়ের সাথে নিট সম্পদ ও সম্পদ মিশ্রণ",
    wlt_fx_convert: "FX রূপান্তর", wlt_from: "থেকে", wlt_to: "প্রতি", wlt_amount: "পরিমাণ",
    wlt_you_receive: "আপনি পাবেন", wlt_convert: "রূপান্তর", wlt_method: "পদ্ধতি",
    wlt_bank_transfer: "ব্যাংক ট্রান্সফার", wlt_card: "কার্ড", wlt_withdraw_bank: "ব্যাংকে উত্তোলন",
    wlt_transactions: "লেনদেন", wlt_no_transactions: "কোনো লেনদেন নেই", wlt_asset: "সম্পদ",
    wlt_class: "শ্রেণি", wlt_value: "মূল্য", wlt_type: "ধরন", wlt_detail: "বিবরণ", wlt_time: "সময়",
    alr_title: "মূল্য অ্যালার্ট",
    alr_subtitle: "কোনো স্টক, ক্রিপ্টো বা পণ্য আপনার লক্ষ্য মূল্যে পৌঁছালে জানুন",
    alr_create: "অ্যালার্ট তৈরি করুন", alr_search: "সিম্বল বা নাম খুঁজুন", alr_target_price: "লক্ষ্য মূল্য",
    alr_direction: "দিক", alr_rises_above: "উপরে ওঠে", alr_falls_below: "নিচে নামে",
    alr_current: "বর্তমান", alr_no_alerts: "এখনও কোনো অ্যালার্ট নেই",
    alr_no_alerts_hint: "একটি মূল্য অ্যালার্ট যোগ করুন, পৌঁছানো মাত্র আমরা জানাব।",
    alr_add: "অ্যালার্ট যোগ করুন",
  },
  pt: {
    cancel: "Cancelar", refresh: "Atualizar", active: "Ativo", triggered: "Acionado", delete: "Excluir",
    nav_alerts: "Alertas",
    mrb_title: "Murabaha de Commodities",
    mrb_subtitle: "Investimento em conformidade com a Sharia em fluxos reais de commodities agrícolas · até 8% ao ano",
    mrb_available_flows: "Fluxos disponíveis", mrb_your_contracts: "Seus contratos",
    mrb_invested_principal: "Principal investido", mrb_accrued_profit: "Lucro acumulado",
    mrb_current_value: "Valor atual", mrb_active_contracts: "Contratos ativos",
    mrb_invest: "Investir", mrb_target_rate: "Taxa-alvo", mrb_tenor: "Prazo", mrb_minimum: "Mínimo",
    mrb_amount_usd: "Valor (USD)", mrb_projected_profit: "Lucro previsto no vencimento",
    mrb_no_contracts: "Ainda sem contratos",
    mrb_no_contracts_hint: "Invista em um fluxo de commodities para começar a lucrar com base no comércio.",
    mrb_redeem_early: "Resgatar antecipado", mrb_redeem_matured: "Resgatar (vencido)",
    mrb_principal: "Principal", mrb_rate_tenor: "Taxa / prazo", mrb_invested: "Investido",
    mrb_payout: "Pagamento", mrb_matures_in: "Vence em", mrb_matured: "Vencido", mrb_days: "dias",
    mrb_target_pa: "alvo ao ano", mrb_month_tenor: "meses de prazo",
    wlt_title: "Carteira", wlt_subtitle: "Saldos unificados QAR e USD · FX e transferências",
    wlt_qar_balance: "Saldo QAR", wlt_usd_balance: "Saldo USD", wlt_total_usd: "Total (equiv. USD)",
    wlt_portfolio_mix: "Composição da carteira", wlt_net_worth: "Patrimônio líquido", wlt_holdings_value: "Valor das posições",
    wlt_total_pnl: "P&L total", wlt_mix_history: "Histórico de composição",
    wlt_mix_history_sub: "Patrimônio e mix de ativos ao longo do tempo",
    wlt_fx_convert: "Conversão FX", wlt_from: "De", wlt_to: "Para", wlt_amount: "Valor",
    wlt_you_receive: "Você recebe", wlt_convert: "Converter", wlt_method: "Método",
    wlt_bank_transfer: "Transferência bancária", wlt_card: "Cartão", wlt_withdraw_bank: "Sacar para o banco",
    wlt_transactions: "Transações", wlt_no_transactions: "Sem transações", wlt_asset: "Ativo",
    wlt_class: "Classe", wlt_value: "Valor", wlt_type: "Tipo", wlt_detail: "Detalhe", wlt_time: "Hora",
    alr_title: "Alertas de preço",
    alr_subtitle: "Seja avisado quando uma ação, cripto ou commodity atingir seu preço-alvo",
    alr_create: "Criar alerta", alr_search: "Buscar símbolo ou nome", alr_target_price: "Preço-alvo",
    alr_direction: "Direção", alr_rises_above: "Sobe acima de", alr_falls_below: "Cai abaixo de",
    alr_current: "Atual", alr_no_alerts: "Ainda sem alertas",
    alr_no_alerts_hint: "Adicione um alerta de preço e avisaremos assim que for atingido.",
    alr_add: "Adicionar alerta",
  },
  ru: {
    cancel: "Отмена", refresh: "Обновить", active: "Активен", triggered: "Сработал", delete: "Удалить",
    nav_alerts: "Оповещения",
    mrb_title: "Товарная Мурабаха",
    mrb_subtitle: "Соответствующие шариату инвестиции в реальные физические потоки сельхозтоваров · до 8% годовых",
    mrb_available_flows: "Доступные потоки", mrb_your_contracts: "Ваши контракты",
    mrb_invested_principal: "Вложенный капитал", mrb_accrued_profit: "Накопленная прибыль",
    mrb_current_value: "Текущая стоимость", mrb_active_contracts: "Активные контракты",
    mrb_invest: "Инвестировать", mrb_target_rate: "Целевая ставка", mrb_tenor: "Срок", mrb_minimum: "Минимум",
    mrb_amount_usd: "Сумма (USD)", mrb_projected_profit: "Прогноз прибыли к погашению",
    mrb_no_contracts: "Контрактов пока нет",
    mrb_no_contracts_hint: "Инвестируйте в товарный поток, чтобы получать торговую прибыль.",
    mrb_redeem_early: "Досрочно погасить", mrb_redeem_matured: "Погасить (созрел)",
    mrb_principal: "Капитал", mrb_rate_tenor: "Ставка / срок", mrb_invested: "Вложено",
    mrb_payout: "Выплата", mrb_matures_in: "Погашение через", mrb_matured: "Созрел", mrb_days: "дн.",
    mrb_target_pa: "цель в год", mrb_month_tenor: "мес. срок",
    wlt_title: "Кошелёк", wlt_subtitle: "Единые балансы QAR и USD · обмен и переводы",
    wlt_qar_balance: "Баланс QAR", wlt_usd_balance: "Баланс USD", wlt_total_usd: "Итого (экв. USD)",
    wlt_portfolio_mix: "Состав портфеля", wlt_net_worth: "Чистые активы", wlt_holdings_value: "Стоимость позиций",
    wlt_total_pnl: "Общий P&L", wlt_mix_history: "История состава",
    wlt_mix_history_sub: "Чистые активы и состав со временем",
    wlt_fx_convert: "Обмен валют", wlt_from: "Из", wlt_to: "В", wlt_amount: "Сумма",
    wlt_you_receive: "Вы получите", wlt_convert: "Конвертировать", wlt_method: "Способ",
    wlt_bank_transfer: "Банковский перевод", wlt_card: "Карта", wlt_withdraw_bank: "Вывод на банк",
    wlt_transactions: "Транзакции", wlt_no_transactions: "Нет транзакций", wlt_asset: "Актив",
    wlt_class: "Класс", wlt_value: "Стоимость", wlt_type: "Тип", wlt_detail: "Детали", wlt_time: "Время",
    alr_title: "Ценовые оповещения",
    alr_subtitle: "Получайте уведомление, когда акция, крипто или товар достигнет целевой цены",
    alr_create: "Создать оповещение", alr_search: "Поиск по тикеру или названию", alr_target_price: "Целевая цена",
    alr_direction: "Направление", alr_rises_above: "Поднимется выше", alr_falls_below: "Опустится ниже",
    alr_current: "Текущая", alr_no_alerts: "Оповещений пока нет",
    alr_no_alerts_hint: "Добавьте оповещение — уведомим сразу при срабатывании.",
    alr_add: "Добавить оповещение",
  },
  ur: {
    cancel: "منسوخ کریں", refresh: "ریفریش", active: "فعال", triggered: "ٹرگر ہوا", delete: "حذف کریں",
    nav_alerts: "الرٹس",
    mrb_title: "کموڈٹی مرابحہ",
    mrb_subtitle: "حقیقی طبعی زرعی اجناس کے بہاؤ میں شریعت کے مطابق سرمایہ کاری · سالانہ 8% تک",
    mrb_available_flows: "دستیاب فلوز", mrb_your_contracts: "آپ کے معاہدے",
    mrb_invested_principal: "سرمایہ کاری شدہ اصل رقم", mrb_accrued_profit: "جمع شدہ منافع",
    mrb_current_value: "موجودہ مالیت", mrb_active_contracts: "فعال معاہدے",
    mrb_invest: "سرمایہ کاری", mrb_target_rate: "ہدف شرح", mrb_tenor: "مدت", mrb_minimum: "کم از کم",
    mrb_amount_usd: "رقم (USD)", mrb_projected_profit: "میچورٹی پر متوقع منافع",
    mrb_no_contracts: "ابھی کوئی معاہدہ نہیں",
    mrb_no_contracts_hint: "تجارت پر مبنی منافع کمانے کے لیے کسی کموڈٹی فلو میں سرمایہ کاری کریں۔",
    mrb_redeem_early: "قبل از وقت وصولی", mrb_redeem_matured: "وصولی (میچور)",
    mrb_principal: "اصل رقم", mrb_rate_tenor: "شرح / مدت", mrb_invested: "سرمایہ کاری شدہ",
    mrb_payout: "ادائیگی", mrb_matures_in: "میچورٹی میں", mrb_matured: "میچور", mrb_days: "دن",
    mrb_target_pa: "سالانہ ہدف", mrb_month_tenor: "ماہ مدت",
    wlt_title: "والیٹ", wlt_subtitle: "مربوط QAR اور USD بیلنس · FX اور ٹرانسفر",
    wlt_qar_balance: "QAR بیلنس", wlt_usd_balance: "USD بیلنس", wlt_total_usd: "کل (USD مساوی)",
    wlt_portfolio_mix: "پورٹ فولیو مکس", wlt_net_worth: "خالص مالیت", wlt_holdings_value: "ہولڈنگز کی مالیت",
    wlt_total_pnl: "کل نفع/نقصان", wlt_mix_history: "مکس ہسٹری",
    wlt_mix_history_sub: "وقت کے ساتھ خالص مالیت اور اثاثہ جات کا امتزاج",
    wlt_fx_convert: "FX تبدیلی", wlt_from: "سے", wlt_to: "تک", wlt_amount: "رقم",
    wlt_you_receive: "آپ کو ملے گا", wlt_convert: "تبدیل کریں", wlt_method: "طریقہ",
    wlt_bank_transfer: "بینک ٹرانسفر", wlt_card: "کارڈ", wlt_withdraw_bank: "بینک میں نکالیں",
    wlt_transactions: "لین دین", wlt_no_transactions: "کوئی لین دین نہیں", wlt_asset: "اثاثہ",
    wlt_class: "قسم", wlt_value: "مالیت", wlt_type: "نوعیت", wlt_detail: "تفصیل", wlt_time: "وقت",
    alr_title: "قیمت الرٹس",
    alr_subtitle: "جب کوئی اسٹاک، کرپٹو یا کموڈٹی آپ کی ہدف قیمت پر پہنچے تو اطلاع پائیں",
    alr_create: "الرٹ بنائیں", alr_search: "سمبل یا نام تلاش کریں", alr_target_price: "ہدف قیمت",
    alr_direction: "سمت", alr_rises_above: "اوپر جائے", alr_falls_below: "نیچے آئے",
    alr_current: "موجودہ", alr_no_alerts: "ابھی کوئی الرٹ نہیں",
    alr_no_alerts_hint: "قیمت الرٹ شامل کریں، پہنچتے ہی ہم آپ کو مطلع کریں گے۔",
    alr_add: "الرٹ شامل کریں",
  },
  tr: {
    cancel: "İptal", refresh: "Yenile", active: "Aktif", triggered: "Tetiklendi", delete: "Sil",
    nav_alerts: "Uyarılar",
    mrb_title: "Emtia Murabahası",
    mrb_subtitle: "Gerçek, fiziksel tarımsal emtia akışlarına Şeriat uyumlu yatırım · yıllık %8'e kadar",
    mrb_available_flows: "Mevcut Akışlar", mrb_your_contracts: "Sözleşmeleriniz",
    mrb_invested_principal: "Yatırılan Anapara", mrb_accrued_profit: "Tahakkuk Eden Kâr",
    mrb_current_value: "Güncel Değer", mrb_active_contracts: "Aktif Sözleşmeler",
    mrb_invest: "Yatırım", mrb_target_rate: "Hedef oran", mrb_tenor: "Vade", mrb_minimum: "Minimum",
    mrb_amount_usd: "Tutar (USD)", mrb_projected_profit: "Vade sonu öngörülen kâr",
    mrb_no_contracts: "Henüz sözleşme yok",
    mrb_no_contracts_hint: "Ticarete dayalı kâr elde etmeye başlamak için bir emtia akışına yatırım yapın.",
    mrb_redeem_early: "Erken boz", mrb_redeem_matured: "Boz (vadesi doldu)",
    mrb_principal: "Anapara", mrb_rate_tenor: "Oran / vade", mrb_invested: "Yatırıldı",
    mrb_payout: "Ödeme", mrb_matures_in: "Vadeye kalan", mrb_matured: "Vadesi doldu", mrb_days: "gün",
    mrb_target_pa: "yıllık hedef", mrb_month_tenor: "ay vade",
    wlt_title: "Cüzdan", wlt_subtitle: "Birleşik QAR ve USD bakiyeleri · FX ve transferler",
    wlt_qar_balance: "QAR Bakiyesi", wlt_usd_balance: "USD Bakiyesi", wlt_total_usd: "Toplam (USD karşılığı)",
    wlt_portfolio_mix: "Portföy Dağılımı", wlt_net_worth: "Net değer", wlt_holdings_value: "Varlık değeri",
    wlt_total_pnl: "Toplam K/Z", wlt_mix_history: "Dağılım Geçmişi",
    wlt_mix_history_sub: "Zaman içinde net değer ve varlık dağılımı",
    wlt_fx_convert: "Döviz Çevir", wlt_from: "Kaynak", wlt_to: "Hedef", wlt_amount: "Tutar",
    wlt_you_receive: "Alacağınız", wlt_convert: "Çevir", wlt_method: "Yöntem",
    wlt_bank_transfer: "Banka havalesi", wlt_card: "Kart", wlt_withdraw_bank: "Bankaya çek",
    wlt_transactions: "İşlemler", wlt_no_transactions: "İşlem yok", wlt_asset: "Varlık",
    wlt_class: "Sınıf", wlt_value: "Değer", wlt_type: "Tür", wlt_detail: "Detay", wlt_time: "Zaman",
    alr_title: "Fiyat Uyarıları",
    alr_subtitle: "Bir hisse, kripto veya emtia hedef fiyatınıza ulaştığında bildirim alın",
    alr_create: "Uyarı oluştur", alr_search: "Sembol veya isim ara", alr_target_price: "Hedef fiyat",
    alr_direction: "Yön", alr_rises_above: "Şunun üzerine çıkarsa", alr_falls_below: "Şunun altına düşerse",
    alr_current: "Güncel", alr_no_alerts: "Henüz uyarı yok",
    alr_no_alerts_hint: "Bir fiyat uyarısı ekleyin, ulaşıldığı anda size bildirelim.",
    alr_add: "Uyarı ekle",
  },
};

const WLT_CURRENCY = {
  en: "Currency", zh: "货币", hi: "मुद्रा", es: "Moneda", fr: "Devise",
  ar: "العملة", bn: "মুদ্রা", pt: "Moeda", ru: "Валюта", ur: "کرنسی", tr: "Para birimi",
};
Object.keys(WLT_CURRENCY).forEach((l) => { if (PAGE_I18N[l]) PAGE_I18N[l].wlt_currency = WLT_CURRENCY[l]; });

Object.keys(PAGE_I18N).forEach((l) => {
  translations[l] = { ...(translations[l] || {}), ...PAGE_I18N[l] };
});

// The public Halal suite (screener, verdicts, leaderboards, Chart Lens, Shariah board, Learn).
Object.keys(HALAL_I18N).forEach((l) => {
  translations[l] = { ...(translations[l] || {}), ...HALAL_I18N[l] };
});
